export default "__VITE_ASSET__24dc779a__"